import z from 'zod';

export type CategoryFilterOptionDto = z.infer<typeof categoryFilterOptionDtoSchema>;
export const categoryFilterOptionDtoSchema = z.object({
  title: z.string(),
  checked: z.boolean(),
  disabled: z.boolean(),
  image: z.string().nullable().optional(),
});

export type FilterOptionDto = z.infer<typeof filterOptionDtoSchema>;
export const filterOptionDtoSchema = z.object({
  title: z.string(),
  checked: z.boolean(),
  disabled: z.boolean(),
});

export type CategoryOptionsResponse = z.infer<typeof categoryOptionsReponseSchema>;
export const categoryOptionsReponseSchema = z.object({
  category: z.object({
    options: z.record(z.string(), categoryFilterOptionDtoSchema),
  }),
});

export type FlavourOptionsResponse = z.infer<typeof flavourOptionsResponseSchema>;
export const flavourOptionsResponseSchema = z.object({
  sensorywheel_flavor: z.object({
    options: z.record(z.string(), filterOptionDtoSchema),
  }),
});

export type TasteOptionsResponse = z.infer<typeof tasteOptionsResponseSchema>;
export const tasteOptionsResponseSchema = z.object({
  sensorywheel_taste: z.object({
    options: z.record(z.string(), filterOptionDtoSchema),
  }),
});

export type MouthfeelOptionsResponse = z.infer<typeof mouthfeelOptionsResponseSchema>;
export const mouthfeelOptionsResponseSchema = z.object({
  sensorywheel_mouthfeel: z.object({
    options: z.record(z.string(), filterOptionDtoSchema),
  }),
});
